<script setup>
import { FIELDS } from '@nineteen-2/dtc-din'
import { computed } from "vue";
import { dinParts } from "@nineteen-2/dtc-registration-form";
import { BookAlertIcon } from "@lucide/vue";

const props = defineProps({
  field: { type : Object},
  registration: { type : Object},
})

const emits = defineEmits(['dinUpdated'])

const fields = computed(() => dinParts(props.field))

// The registration form works the recommendation out from the skier's inputs, and keeps the
// selected setting on it until the registrant chooses another.
const din = computed(() => props.registration?.[fields.value[FIELDS.RECOMMENDED]?.key] ?? null)
const dinSelected = computed(() => props.registration?.[fields.value[FIELDS.SELECTED]?.key] ?? null)

const onSelect = (value) => {
  emits('dinUpdated', {
    [fields.value[FIELDS.SELECTED].key] : value
  })
}
</script>
<template>
  <div v-if="props?.field" class="row">
    <div class="form-group col-md-6">
      <label :for="'registration_' + fields[FIELDS.RECOMMENDED].key">
        {{ fields[FIELDS.RECOMMENDED].templateOptions.label }}
        <small v-if="fields[FIELDS.RECOMMENDED].templateOptions.required" class="align-middle font-weight-bold text-danger">*</small>
      </label>
      <input :type="fields[FIELDS.RECOMMENDED]?.templateOptions?.type ?? 'text'"
             :id="'registration_' + fields[FIELDS.RECOMMENDED].key"
             :value="din"
             :class="[
                           'form-control',
                         ]"
             readonly />
    </div>

    <div class="form-group col-md-6">
      <label :for="'registration_' + fields[FIELDS.SELECTED].key">
        {{ fields[FIELDS.SELECTED].templateOptions.label }}
        <small v-if="fields[FIELDS.SELECTED].templateOptions.required" class="align-middle font-weight-bold text-danger">*</small>
      </label>
      <input :type="fields[FIELDS.SELECTED]?.templateOptions?.type ?? 'text'"
             :id="'registration_' + fields[FIELDS.SELECTED].key"
             :value="dinSelected"
             @input="onSelect($event.target.value)"
             min="0.75"
             max="30"
             step="0.25"
             :class="[
                             'form-control',
                           ]"
             />
    </div>
    <div class="col"
         v-if="fields[FIELDS.SELECTED].templateOptions.tooltip && dinSelected !== din"
    >
      <span class="text-danger">
        <BookAlertIcon/> {{ fields[FIELDS.SELECTED].templateOptions.tooltip }}
      </span>
    </div>
  </div>
</template>
